module.exports = __webpack_public_path__ + "img/0-3years.afa198e0.svg";